const GET_DELIVERY_INFO_DATA_START = 'GET_DELIVERY_INFO_DATA_START';
const GET_DELIVERY_INFO_DATA_SUCCESS = 'GET_DELIVERY_INFO_DATA_SUCCESS';
const GET_DELIVERY_INFO_DATA_ERROR = 'GET_DELIVERY_INFO_DATA_ERROR';

const DELIVERY_INFO_DATA_LOADING = 'DELIVERY_INFO_DATA_LOADING';

const getDeliveryInfoStart = (companyId) => {
	return {
		type: GET_DELIVERY_INFO_DATA_START,
		companyId,
	};
};

const getDeliveryInfoSuccess = (res) => {
	return {
		type: GET_DELIVERY_INFO_DATA_SUCCESS,
		res,
	};
};

const getDeliveryInfoError = () => {
	return {
		type: GET_DELIVERY_INFO_DATA_ERROR,
	};
};

export default {
	types: {
		GET_DELIVERY_INFO_DATA_START,
		GET_DELIVERY_INFO_DATA_SUCCESS,
		GET_DELIVERY_INFO_DATA_ERROR,
		DELIVERY_INFO_DATA_LOADING,
	},
	creators: {
		getDeliveryInfoStart,
		getDeliveryInfoSuccess,
		getDeliveryInfoError,
	},
};
